<template>
  <div class="flex flex-col gap-16">
    <h3 class="text-static-default-mid body-2">{{ title }}</h3>
    <ul class="flex flex-col">
      <li
        v-for="(suggestion, index) in suggestions"
        :key="suggestion.title"
        class="group relative"
        data-test="search-bar-dropdown-item"
      >
        <RevButtonBase
          class="rounded-sm body-1-bold block p-8 pr-32 hover:bg-static-default-min-hover hover:no-underline"
          :to="suggestion.url"
          :underlined="false"
          @click="
            () => {
              $emit('submit')
              trackFormSubmit({
                name: suggestion.title,
                payload: { index_used: index, search_type: name },
                zone: 'header_searchbar',
              })
            }
          "
        >
          <span>
            {{ suggestion.title }}
          </span>
        </RevButtonBase>
        <RevButtonIcon
          class="absolute right-8 top-8 h-24 w-24 group-hover:visible motion-safe:transition motion-safe:duration-300 motion-safe:ease-in md:invisible"
          :icon="IconArrowUpLeft"
          variant="secondary"
          @click.stop="() => $emit('select', suggestion.title)"
        />
      </li>

      <li v-if="inputValue">
        <RevButtonBase
          class="rounded-sm body-1-bold flex items-center gap-8 p-8 hover:bg-static-default-min-hover hover:no-underline"
          :title="inputValue"
          :to="`/${locale}/search?q=${inputValue}`"
          @click="
            () => {
              $emit('submit')
              trackFormSubmit({
                name: inputValue as string,
                payload: { index_used: -1, search_type: 'userInput' },
                zone: 'header_searchbar',
              })
            }
          "
        >
          <IconSearch class="h-24 w-24 flex-none" />
          <span class="truncate">"{{ inputValue }}"</span>
        </RevButtonBase>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevButtonBase } from '@ds/components/ButtonBase'
import { RevButtonIcon } from '@ds/components/ButtonIcon'
import { IconArrowUpLeft } from '@ds/icons/IconArrowUpLeft'
import { IconSearch } from '@ds/icons/IconSearch'

import type { Link } from '../algolia/algoliaFunctions'

defineProps<{
  name: 'suggestions' | 'popularSearches'
  inputValue?: string
  suggestions: Array<Link>
  title: string
}>()

defineEmits(['select', 'submit'])

const locale = useI18nLocale()
const { trackFormSubmit } = useTracking()
</script>
